import { NotificationType } from "@sol/sdk";

const FOLLOW_UP_TYPES = [
    NotificationType.FOLLOW_UP_TO_LEARNER,
    NotificationType.FOLLOW_UP_TO_TRAINER,
    NotificationType.FOLLOW_UP_TO_TUTOR,
];

const SELF_EVALUATION_TYPES = [NotificationType.SELF_EVALUATION_TO_TRAINER, NotificationType.SELF_EVALUATION_TO_TUTOR];

const BRIEF_TYPES = [NotificationType.BRIEF_COEDITOR_ADDED_TO_TRAINER, NotificationType.BRIEF_COEDITED_TO_CREATOR];

export const isFollowUpNotification = (type: NotificationType) => FOLLOW_UP_TYPES.includes(type);

export const isSelfEvaluationNotification = (type: NotificationType) => SELF_EVALUATION_TYPES.includes(type);

export const isBriefNotification = (type: NotificationType) => BRIEF_TYPES.includes(type);

export const isGroupNotification = (type: NotificationType) => type.startsWith("group_");
